import React, { Component, Fragment } from 'react';

import store from '../store/store.js'

import {List, ListItem} from 'material-ui/List';
import Subheader from 'material-ui/Subheader';

import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import {Toolbar, ToolbarGroup, ToolbarSeparator, ToolbarTitle} from 'material-ui/Toolbar';
import RaisedButton from 'material-ui/RaisedButton';

const RzhdHotels = (props) => {
  var subheader = '';

  const hotels = store.hotels.filter((hotel)=>{
    const ln = store.links;
    const tid = store.tursID;
    for (var i = 0; i < ln.length; i++ ) {
      if (ln[i].idotel === hotel.id && tid[ln[i].idtur].type === 'ЖД') return true;
    }
    return false;
  });

  const handleClick = (hotel) => {
    store.setHotel(hotel); 
    props.click();
  }

  const listrow = (row, index) => {
    var Sub = null;
    if (subheader !== row.hotelgroup) {
      subheader = row.hotelgroup; 
      Sub = ( <TableRow>
                <TableRowColumn style={{width: "85%"}}>
                  <h2>{subheader}</h2>
                  <p> город: <b>{row.city}</b> </p>
                </TableRowColumn>
                <TableRowColumn> </TableRowColumn>
              </TableRow> ) 
      } 

    return (  <Fragment key={row.id}>
                {Sub}
              <TableRow >
                <TableRowColumn style={{width: "85%"}}> {row.name} </TableRowColumn>
                <TableRowColumn>
                  <RaisedButton label="Выбрать" 
                    onClick={()=>{ handleClick(row) } }
                    primary={ true }
                    />
                </TableRowColumn>
              
              </TableRow>
              </Fragment>);
  } //end listRow
    
    return (
    <Table selectable={false}>
      <TableHeader adjustForCheckbox={false} displaySelectAll={false}>
        <TableRow>
          <TableHeaderColumn style={{width: "85%"}}>Отель</TableHeaderColumn>

          <TableHeaderColumn ></TableHeaderColumn>
        </TableRow>
      </TableHeader>
      <TableBody 
        displayRowCheckbox={false}
        >
      {hotels.map(listrow)}

      </TableBody>
      
    </Table>

    )
}


export default RzhdHotels;




// WEBPACK FOOTER //
// ./src/coms/RzhdHotels.jsx